import {
  ActionIcon,
  Group,
  MultiSelect,
  MultiSelectProps,
  Select,
  SelectProps,
  Tooltip,
} from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import { useGetManyEthnicitiesQuery } from '@api/ethnicities.api';

type EthnicitySelectorProps =
  | (Omit<
      SelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple?: false;
    })
  | (Omit<
      MultiSelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple: true;
    });

export default function EthnicitySelector(props: EthnicitySelectorProps) {
  // ==========================================================================
  // Api

  // ==========================================================================
  const {
    data = [],
    isLoading,
    refetch,
  } = useGetManyEthnicitiesQuery({
    sortBy: 'name',
    sortOrder: 'asc',
  });

  // ==========================================================================
  // Render
  // ==========================================================================
  return props.multiple ? (
    <MultiSelect
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessuna etnia trovata"
      placeholder={
        props.value?.length || 0 > 0 ? undefined : 'Seleziona le etnie'
      }
      data={data.map((ethnicity) => ({
        value: ethnicity.id,
        label: ethnicity.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  ) : (
    <Select
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessuna etnia trovata"
      placeholder="Seleziona l'etnia"
      data={data.map((ethnicity) => ({
        value: ethnicity.id,
        label: ethnicity.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  );
}
